export default "__VITE_ASSET__sK1tzo$J__"